// extracted by mini-css-extract-plugin
module.exports = {"monitor-service-fields":"x29ZZW2cJW9mx-0Lh6qf","monitor-service-fields__title":"_3MeguaM_S3NV5esbpOCr1t","monitor-service-fields__content":"_28AkVfA9KYX1icm84g-O2o"};